ITERATION_SUPPORT